function deepTrim(str) {
  return str.replace(/\s+/g, " ").trim();
}
function sanitizePostgresJSONString(str) {
  return str.replaceAll("\0", "");
}
function lowercase(value) {
  return value.toLowerCase();
}

export { deepTrim, lowercase, sanitizePostgresJSONString };
